import React, { useState, useEffect } from "react";
import { withStyles, Grid } from "@material-ui/core";
import { getCountries } from "../../../../../../API/Country";
import { styles } from "./styles";

import TextField from "../../../../../../Component/Forms/TextField";
import SearchableSelect from "../../../../../../Component/Forms/SearchableSelect";
import { useTranslation } from "react-i18next";

const ExchangeForm = (props) => {
  const { onFieldChange, formErrors, classes } = props;
  const { t } = useTranslation();

  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState(null);
  const [equivalent, setEquivalent] = useState(null);

  const options = [
    {
      label: t("labels.common.yes"),
      value: 1,
    },
    {
      label: t("labels.common.no"),
      value: 0,
    },
  ];
  
  useEffect(() => {
    const loadCountries = async () => {
      try {
        const result = await getCountries();
        const { data = [] } = result;
        setCountries(data.map((val) => ({ value: val.id, label: val.name })));
      } catch (error) {
        console.log(error);
      }
    };
    loadCountries();
  }, []);

  const handleNameChange = (value) => {
    onFieldChange && onFieldChange(value, "exchange_name");
  };

  const handleCodeChange = (value) => {
    onFieldChange && onFieldChange(value, "exchange_code");
  };

  const handleCountryChange = (c) => {
    setCountry(c)
    onFieldChange && onFieldChange(c ? c.value : null, "country_id");
  };

  const handleEquivalentChange = (eq) => {
    setEquivalent(eq)
    onFieldChange && onFieldChange(eq ? eq.value : null, "is_equivalent");
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <TextField
          label={t("labels.country.exchangeList.exchangeForm.exchangeCode")}
          required={true}
          type="text"
          onChange={handleCodeChange}
        />
        {formErrors["exchange_code"] && <div className={classes.errorText}>{formErrors["exchange_code"]}</div>}
      </Grid>
      <Grid item xs={9}>
        <TextField
          label={t("labels.country.exchangeList.exchangeForm.exchangeName")}
          required={true}
          type="text"
          onChange={handleNameChange}
        />
        {formErrors["exchange_name"] && <div className={classes.errorText}>{formErrors["exchange_name"]}</div>}
      </Grid>
      <Grid item xs={6}>
        <SearchableSelect
          label={t("labels.country.exchangeList.exchangeForm.country")}
          options={countries}
          value={country}
          changeHandler={handleCountryChange}
          required={true}
        />
        {formErrors["country_id"] && <div className={classes.errorText}>{formErrors["country_id"]}</div>}
      </Grid>
      <Grid item xs={3}>
        <SearchableSelect
          label={t("labels.country.exchangeList.exchangeForm.equivalent")}
          options={options}
          value={equivalent}
          changeHandler={handleEquivalentChange}
          disableClearable={true}
          required={true}
        />
      </Grid>
    </Grid>
  );
};

export default withStyles(styles, { withTheme: true })(ExchangeForm);
